import { render, staticRenderFns } from "./Complementario.vue?vue&type=template&id=1d468390"
import script from "./Complementario.vue?vue&type=script&lang=js"
export * from "./Complementario.vue?vue&type=script&lang=js"
import style0 from "./Complementario.vue?vue&type=style&index=0&id=1d468390&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports